import { getContrastColorFromRGBA, getEffectiveBg } from "../helpers/contrastColor";
import store from "../../../shared/core/store";

const vContrast = {
  inserted(el: HTMLElement) {
    if (el.classList.contains("main-border-color")) {
      return;
    }
    const isDarkMode = store.state.settings.DarkMode === true;
    const bg = getEffectiveBg(el);
    if (!bg) {
      return;
    }     

    let textColor: string;
    if (bg.r === 0 && bg.g === 0 && bg.b === 0 && bg.a === 0) {
      textColor = isDarkMode ? "#FFFFFF" : "#000000";
    } else {
      textColor = getContrastColorFromRGBA(bg.r, bg.g, bg.b, bg.a);
    }
    el.style.color = textColor;
    const targets = el.querySelectorAll('p, span, strong, em, b, i, small, label, icon');
    targets.forEach((child: Element) => {
      (child as HTMLElement).style.color = textColor;
    });
  },
};

export default vContrast;